import { combineReducers } from "redux";
import { sessionReducer } from "redux-react-session";
import { alert } from "./alertReducer";
import { dashboard } from "./dashboardReducer";
import { productGroup } from "./productGroupReducer";
import { demo } from "./demoReducer";
import { feedback } from "./feedbackReducer";
import { survey } from "./surveyReducer";
import { competitiveDash } from "./competitiveDashReducer"
import { competetiveProducts } from "./competeteiveProductsReducer";
import { adminCompetitiveDash } from "./adminDashboardReducer.js";
import { storageApplication } from "./storageReducers.js";
import { adminDataManager } from "./adminDataMangerReducer.js";
import { storageAdminDataManager } from "./storageAdminDataManagerReducer.js";
import { notificationReducer } from "./notificationReducer.js";

const reducers = combineReducers({
	alert: alert,
	session: sessionReducer,
	dashboard: dashboard,
	productGroup: productGroup,
	demo: demo,
	feedback: feedback,
	survey: survey,
	competitiveDash: competitiveDash,
	competitiveProducts: competetiveProducts,
	adminCompetitiveDash: adminCompetitiveDash,
	storageApplication: storageApplication,
	adminDataManager: adminDataManager,
	storageAdminDataManager: storageAdminDataManager,
	notification: notificationReducer,
});

export default reducers;
